import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { appConfig } from '../../init/getAppConfig';
import { getAddressApiKey } from '../../utils/getAddressApiKey';

@Injectable({
  providedIn: 'root',
})
export class AddressAutocompleteService {
  private addressApiUrl: string;
  private addressApiKey: string;
  constructor(private http: HttpClient) {
    this.addressApiUrl = appConfig.addressApiBaseUrl;
    this.addressApiKey = getAddressApiKey();
  }

  searchAddress(searchTerms: string): Observable<any[]> {
    const filteredAddressOptions = [];
    // Show filtered results
    if (searchTerms) {
      return this.getAddress(searchTerms).pipe(
        map((results) => {
          const addressOptions: any[] = results.Items;
          addressOptions.forEach((option) => {
            option.Text = option.Text + ', ' + option.Description;
          });
          addressOptions.forEach((option) => {
            if (
              searchTerms !== '' &&
              option.Text.toLocaleLowerCase().includes(
                searchTerms
                  .toLowerCase()
                  .replace(/,/g, '')
                  .replace(/./g, '')
                  .replace(/'/g, '')
              )
            ) {
              filteredAddressOptions.push(option);
            }
          });
          if (filteredAddressOptions.length === 0 && searchTerms !== '') {
            filteredAddressOptions.push({ noAddressFound: true });
          }
          return filteredAddressOptions;
        })
      );
    }
  }

  getAddress(searchTerms: string, lastId?: string): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append('key', this.addressApiKey);
    params = params.append('searchTerm', searchTerms);
    if (lastId) {
      params = params.append('lastId', lastId);
    }
    return this.http.get(this.addressApiUrl, { params: params });
  }
}
